import {createContext} from 'react';

import type {MixPanelService} from './mixpanel.service';

// Dans son propre fichier, et non à côté du composant : React Fast Refresh ne
// sait rafraîchir à chaud qu'un module n'exportant QUE des composants. Un
// contexte exporté depuis `MixpanelProvider.tsx` y faisait renoncer, et chaque
// édition du provider provoquait un rechargement complet de la page.
export const MixpanelCtx = createContext<MixPanelService | undefined>(undefined);
